export const ENTITY_TYPE_ICON_OPTIONS = [
	'collection',
	'dictionary_term',
	'document',
	'metric',
	'question',
	'bi_dashboard',
	'bi_metric',
] as const;

export type EntityTypeIconOptions = (typeof ENTITY_TYPE_ICON_OPTIONS)[number];
